/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unescaped-entities */

// Images and GIFs
import swipelyticsSpinnerGIF from '../assets/swipelytics-spinner-4.gif'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// Standard Error Container
export const standardErrorContainer = (errorText, marginBottom, marginTop) => {
  return (
    <Box sx={{ 
      width: '100%',
      display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
      mb: marginBottom, mt: marginTop,
    }}>
      <Typography variant='p' sx={{ color: 'red' }}>
        {errorText}
      </Typography>
    </Box>
  )
}

// Email/Password login/registration errors
export const loginRegisterErrors = (isError, errorText, marginTop, marginBottom) => {
  return (
    <>
      {isError && 
        <Box  sx={{ width: '100%', mt: marginTop, mb: marginBottom }}>
          {standardErrorContainer(errorText)}
        </Box>  
      }
    </>
  )
}


export const couldNotLoadPageError = () => {
  return (
    <Typography
      // textAlign={'center'}
      sx={{
        width: '80%',
        fontWeight: 'bold',
        color: 'blue',
        display: 'flex', flexDirection: 'row', justifyContent: 'center',
      }}
    >
      Could not load page. Check your Internet connection and try again.
    </Typography>
  )
}